import axios from 'axios'
import { similarity } from '../../helpers/addressParser'

const CHILE_COUNTRY_ID = 'CL'

export default class MagentoClient {
  constructor (domain, quoteId, currentUrl) {
    this.domain = domain
    this.quoteId = quoteId
    this.currentUrl = currentUrl
    this.apiUrl = ''
    this.headers = {
      'content-type': 'application/json'
    }
    this.setApiUrl()
  }

  setApiUrl () {}

  async fetchInformation (path, method = 'get', data = {}, baseUrl = this.apiUrl) {
    const url = `${baseUrl}${path}`
    const response = await axios({
      method,
      url,
      data,
      headers: this.headers
    })
    return response
  }

  async getCart () {
    const response = await this.fetchInformation('')
    return response.data
  }

  async getCartTotals () {
    const response = await this.fetchInformation('/totals')
    return response.data
  }

  async getPaymentMethods () {
    const response = await this.fetchInformation('/payment-methods')
    return response.data
  }

  async estimateShippingMethods (addressInfo, userInfo) {
    const address = await this.parseAddressToEstimateShipping(addressInfo, userInfo)
    try {
      const response = await this.fetchInformation('/estimate-shipping-methods', 'post', { address })
      return response.data
    } catch (error) {
      console.error('Error estimating shipping methods', error)
    }
  }

  async parseAddressToEstimateShipping (addressInfo, userInfo) {
    const region = await this.getRegionBasedOnName(addressInfo.region)
    const address = {
      country_id: CHILE_COUNTRY_ID,
      city: addressInfo.district,
      email: userInfo.email,
      firstname: userInfo.names.split(' ')[0],
      lastname: userInfo.names.split(' ')[1],
      postcode: addressInfo?.postalCode,
      region: region.name,
      region_code: region.code,
      region_id: region.id,
      street: addressInfo.userAddress.split(' '),
      telephone: userInfo.phone

    }

    return address
  }

  async getRegionBasedOnName (regionName, countryId = CHILE_COUNTRY_ID) {
    const directoryCountryList = await this.getDirectoryCountryList()
    const country = directoryCountryList.find(country => country.id === countryId)
    // Find region code based on region name similarity
    const mostSimilarRegion = country.available_regions.reduce((acc, region) => {
      const similarityScore = similarity(region.name, regionName)
      if (similarityScore > acc.similarityScore) {
        return { similarityScore, region }
      }
      return acc
    }
    , { similarityScore: 0, region: null })
    return mostSimilarRegion.region
  }

  async getDirectoryCountryList () {
    try {
      const response = await this.fetchInformation('/rest/default/V1/directory/countries', 'get', {}, this.domain)
      return response.data
    } catch (error) {
      console.error('Error getting directory country list', error)
    }
  }

  async addDiscountCode (discountCode) {
    const response = await this.fetchInformation(`/coupons/${discountCode}`, 'put')
    return response.data
  }

  async removeDiscountCode (discountCode) {
    const response = await this.fetchInformation('/coupons/', 'delete')
    return response.data
  }
}
